import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateWorkflowAssistantIncorrectAnswerReport, CreateWorkflowAssistantSuggestion, UpdateWorkflowAssistantSuggestion, WorkflowAssistantSuggestion } from './workflow-assistant.models';

@Injectable({ providedIn: 'root' })
export class WorkflowAssistantSuggestionService {
  private readonly url = `${environment.urls.baseApiUrl}/WorkflowAssistant/Suggestions`;

  constructor(private http: HttpClient) { }

  /**
   * Loads the audited suggestion queue available to Super Administrators.
   */
  getAll(): Observable<WorkflowAssistantSuggestion[]> {
    return this.http.get<WorkflowAssistantSuggestion[]>(this.url);
  }

  /**
   * Persists a question suggestion under the authenticated user's identity.
   * @param suggestion Question and expected ASCC behavior to preserve for triage.
   */
  create(suggestion: CreateWorkflowAssistantSuggestion): Observable<WorkflowAssistantSuggestion> {
    return this.http.post<WorkflowAssistantSuggestion>(this.url, suggestion);
  }

  /**
   * Records an incorrect answer with its original question and authenticated reporter.
   * @param report Exchange and correction details to preserve for SA review.
   */
  reportIncorrectAnswer(report: CreateWorkflowAssistantIncorrectAnswerReport): Observable<WorkflowAssistantSuggestion> {
    return this.http.post<WorkflowAssistantSuggestion>(`${environment.urls.baseApiUrl}/WorkflowAssistant/IncorrectAnswerReports`, report);
  }

  /**
   * Saves the review state and developer notes for a queued suggestion.
   * @param id Suggestion identifier.
   * @param update Review fields to persist.
   */
  update(id: number, update: UpdateWorkflowAssistantSuggestion): Observable<WorkflowAssistantSuggestion> {
    return this.http.put<WorkflowAssistantSuggestion>(`${this.url}/${id}`, update);
  }
}
